import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { ApiQueryAutocomplete } from "../../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import {
    FetchPriceListsResponse,
    PriceListType,
    fetchPriceLists,
    PriceListQuery,
} from "../../../priceList/priceListApi"
import { useMerchant } from "../../../../../merchants/merchantHooks"

const useStyles = makeStyles()((_theme) => ({
    input: {
        width: "22rem",
        backgroundColor: "white",
    },
}))

const selectPriceLists = (data: FetchPriceListsResponse) => data?.priceLists || []

type PriceListSelectorProps = Readonly<{
    priceListItem: PriceListType | null
    handleChange: (el: PriceListType | null) => void
}>

export const PriceListSelector = memo(({ priceListItem, handleChange }: PriceListSelectorProps) => {
    const { classes } = useStyles()
    const { merchantId } = useMerchant()

    const {
        data: priceLists = [],
        isLoading,
        isError,
    } = useApiQuery(fetchPriceLists, {
        queryName: PriceListQuery.LIST,
        dependencies: {
            merchantId: merchantId,
        },
        select: selectPriceLists,
    })

    return (
        <>
            <LocalizedStrict id="products-page-table-price-list-label" attrs={{ label: true }}>
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={priceLists}
                    value={priceListItem}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) => handleChange(value)}
                    label="Price list"
                    slotProps={{
                        textField: { className: classes.input },
                        errorSelect: { className: classes.input },
                    }}
                />
            </LocalizedStrict>
        </>
    )
})
